import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import FontAwesomeIcon from "../node_modules/font-awesome/css/font-awesome.min.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
